/**
 * 时间格式化函数
 * 时间格式化函数，将 Date 转化为指定格式的String
 * 例子：
 * (new Date()).Format("yyyy-MM-dd hh:mm:ss") ==> 2006-07-02 08:09:04
 * (new Date()).Format("yyyy-MM-dd)      ==> 2006-07-02
 * @param {Date} date
 * @param {String} fmt
 */
export function formatDate (date, fmt = 'yyyy-MM-dd') {
  const d = new Date(date)
  // 将年月日时分秒格式化为string类型
  const newDate = {
    year: `${d.getFullYear()}`,
    month: `${d.getMonth() + 1}`.length > 1 ? `${d.getMonth() + 1}` : `0${d.getMonth() + 1}`,
    day: `${d.getDate()}`.length > 1 ? `${d.getDate()}` : `0${d.getDate()}`,
    hours: `${d.getHours()}`.length > 1 ? `${d.getHours()}` : `0${d.getHours()}`,
    minutes: `${d.getMinutes()}`.length > 1 ? `${d.getMinutes()}` : `0${d.getMinutes()}`,
    seconds: `${d.getSeconds()}`.length > 1 ? `${d.getSeconds()}` : `0${d.getSeconds()}`
  }
  // 判断需要修改成的格式
  if (fmt === 'yyyy-MM-dd') {
    return `${newDate.year}-${newDate.month}-${newDate.day}`
  } else if (fmt === 'yyyy-MM-dd hh:mm:ss') {
    return `${newDate.year}-${newDate.month}-${newDate.day} ${newDate.hours}:${newDate.minutes}:${newDate.seconds}`
  } else if (fmt === 'yyyy-MM-dd hh:mm') {
    return `${newDate.year}-${newDate.month}-${newDate.day} ${newDate.hours}:${newDate.minutes}`
  } else {
    return false
  }
}
/**
 * 深拷贝函数
 * @param {Object} obj
 */
export function deepClone (obj) {
  const objClone = Array.isArray(obj) ? [] : {}
  if (obj && typeof obj === 'object') {
    for (const key in obj) {
      // 判断key是否为obj自身（非继承）的属性
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key)) {
        // 判断ojb子元素是否为对象，如果是，递归复制
        if (obj[key] && typeof obj[key] === 'object') {
          objClone[key] = this.deepClone(obj[key])
        } else {
          // 如果不是，简单复制
          objClone[key] = obj[key]
        }
      }
    }
  }
  return objClone
}
/**
 * 手机号校验
 * @param {String} num
 */
export function testPhoneNum (num) {
  const rep = /^1[3456789]\d{9}$/ // 手机号的正则
  if (rep.test(num)) {
    return true
  } else {
    return false
  }
}
/**
 * 身份证号校验
 * @param {String} idcard
 */
export function testIDCard (idcard) {
  // 18位身份证号码
  const _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  // 15位身份证号码
  const _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/

  if (_IDRe18.test(idcard) || _IDre15.test(idcard)) {
    return true
  } else {
    return false
  }
}
/**
 *将数据整合成树形
 * @param {Array} arr
 * @param {Number} id
 */
export function sonsTree (arr, id) {
  var temp = [] // 记录经过评级的数据
  var lev = 0 // 记录每条数据的等级
  var forFn = function (arr, id, lev) {
    for (var i = 0; i < arr.length; i++) {
      var item = arr[i]
      if (item.parent_id === id) {
        item.lev = lev
        temp.push(item)
        forFn(arr, item.id, lev + 1) // 循环调用直至
      }
    }
  }
  forFn(arr, id, lev)
  return temp
}
/**
 *设置meta
 * @param {String} metaName
 * @param {String} metaContent
 */
export function setMeta (metaName, metaContent) {
  const head = document.querySelectorAll('head')
  const meta = head[0].querySelectorAll('meta')

  if (metaContent) {
    let isNode = false // 未创建
    for (let i = 0; i < meta.length; i++) {
      if (meta[i].name === metaName) {
        isNode = true
      }
    }
    // 关键字结点已创建
    if (isNode) {
      for (let i = 0; i < meta.length; i++) {
        if (meta[i].name === metaName) {
          meta[i].content = metaContent
        }
      }
    } else {
      // 节点未创建则新建节点
      const metaNode = document.createElement('meta')

      // 配置节点属性
      metaNode.name = metaName
      metaNode.content = metaContent

      // 插入节点
      head[0].appendChild(metaNode)
    }
  }
}
/**
 * 对象判空
 * @param {Object} obj
 */
export function isEmptyObj (obj) {
  for (const i in obj) {
    return false
  }
}
/**
 * 生成排序树
 * @param {Array} data 需要排树的数组
 * @param {Number} pid 根据那个parent_id排
 */
export function convertToTreeData (data, pid) {
  const result = []
  let temp = []
  for (let i = 0; i < data.length; i++) {
    if (data[i].parent_id === pid) {
      const obj = {
        title: data[i].name,
        id: data[i].id
      }
      temp = this.convertToTreeData(data, data[i].id)
      if (temp.length > 0) {
        obj.child = temp
      }
      result.push(obj)
    }
  }
  return result
}
/**
   * 按关键字排序
   * @param { Array } array // 需要排序的数组
   * @param { String } key // 按哪个属性
   */
export function objArraySort (array, key) {
  return array.sort(function (a, b) {
    var x = a[key]
    var y = b[key]
    return x < y ? -1 : x > y ? 1 : 0
  })
}
/**
 *判断是否json字符串
 * @param {String} str
 */
export function isJSON (str) {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}
/**
 * 菜单处理函数
 * @param {Array} data 菜单的数组
 * @param {Number} pid 根据那个parent_id排
 */
export function menuHandleData (data, pid) {
  const result = []
  let temp = []
  for (let i = 0; i < data.length; i++) {
    if (data[i].parent_id === pid) {
      const obj = {
        id: data[i].id,
        name: data[i].name,
        code: data[i].code,
        type: data[i].type,
        parent_id: data[i].parent_id,
        icon: data[i].icon,
        url: data[i].url,
        remark: data[i].remark,
        status: data[i].status,
        is_edit: data[i].is_edit,
        sort: data[i].sort,
        module_id: data[i].module_id
      }
      temp = menuHandleData(data, data[i].id)
      obj.children = temp // 设置子数组
      result.push(obj)
    }
  }
  return result
}
/**
   *  获取树结点的所有子节点
   * @param {Array} data 树的数组
   * @param {Number} pid 父级id
   * @param {Array} res 子级id数组
   */
export function convertToTree (data, pid, res = []) {
  for (let i = 0; i < data.length; i++) {
    if (data[i].parent_id === pid) {
      res.push(data[i].id)
      res = this.convertToTree(data, data[i].id, res)
    }
  }
  return res
}
